import {
  faArrowLeftLong,
  faCoins,
  faFileContract,
  faLink,
  faPersonChalkboard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADEMICYEARID,
  ACADIMAC,
  ADDLESSON,
  baseURL,
  EDITLESSON,
  UPDATELESSON,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";

export default function UpdateLesson() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const [Academacs, setAcademacs] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const { triggerRefresh } = useDataRefresh();
  const [assignmentFile, setAssignmentFile] = useState(null);
  
  const [data, setData] = useState({
    academicYear: "",
    chapter: "",
    lessonName: "",
    lessonDescription: "",
    lessonContent: "",
    lessonVideoUrl: "",
    assignmentTitle: "",
    assignmentDescription: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }

  //1/ جلب بيانات الشهر للتعديل
  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${UPDATELESSON}/${id}`)
        .then((res) => {
          const item = res.data?.data ?? {};
          setData({
            academicYear: item.academicYear || item.academic_year_id || "",
            chapter: item.chapter || item.chapter_id || "",
            lessonName: item.lessonName || item.lesson_name || "",
            lessonDescription: item.lessonDescription || item.lesson_description || "",
            lessonContent: item.lessonContent || item.lesson_content || "",
            lessonVideoUrl: item.lessonVideoUrl || item.lesson_video_url || "",
            assignmentTitle: item.assignment_title || "",
            assignmentDescription: item.assignment_description || "",
          });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الشهر");
        });
    }
  }, [id, axiosPrivate]);

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("_method", "PUT");
      formData.append("academicYear", data.academicYear);
      formData.append("chapter", data.chapter);
      formData.append("lessonName", data.lessonName);
      formData.append("lessonDescription", data.lessonDescription || "");
      formData.append("lessonContent", data.lessonContent || "");
      formData.append("lessonVideoUrl", data.lessonVideoUrl);
      formData.append("save", save ? "1" : "0");
      
      formData.append("assignmentTitle", data.assignmentTitle || "");
      formData.append("assignmentDescription", data.assignmentDescription || "");
      if (assignmentFile) {
        formData.append("assignmentFile", assignmentFile);
      }

      const response = await axiosPrivate.post(`${baseURL}/${EDITLESSON}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("تم الحفظ بنجاح");

      setData({
        academicYear: "",
        chapter: "",
        lessonName: "",
        lessonDescription: "",
        lessonContent: "",
        lessonVideoUrl: "",
        assignmentTitle: "",
        assignmentDescription: "",
      });
      setAssignmentFile(null);

      triggerRefresh();
      if (nav) {
        Navigate("/DashboardLayout/content/lessons");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);
      const errMsg = error.response?.data?.Message || error.response?.data?.message || "حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً";
      toast.error(errMsg);
    } finally {
      setLoding(false);
    }
  }

  // ✅ تحميل السنوات الدراسية مرة واحدة
  useEffect(() => {
    async function fetchAcademics() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);
        if (res.data && res.data.data) {
          setAcademacs(res.data.data);
        }
      } catch (err) {
        console.error("خطأ في تحميل السنوات الدراسية:", err);
        toast.error("فشل تحميل السنوات الدراسية");
      }
    }
    fetchAcademics();
  }, [axiosPrivate]);

  // ✅ تحميل الفصول عند اختيار سنة دراسية
  useEffect(() => {
    async function featchmonth() {
      if (data.academicYear) {
        const res = await axiosPrivate.get(
          `${baseURL}/${ACADEMICYEARID}/${data.academicYear}`
        );
        setSelectData(res.data.data);
      }
    }
    featchmonth();
  }, [data.academicYear, axiosPrivate]);

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/content/lessons"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold">تعديل الدرس</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="mb-5" controlId="city">
              <Form.Label> المرحلة الدراسيه</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicYear"
                value={data.academicYear}
                onChange={handleChange}
              >
                <option value="">----</option>
                {Academacs.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-5" controlId="city">
              <Form.Label> الشهر الدراسي:</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="chapter"
                value={data.chapter}
                onChange={handleChange}
              >
                <option value="">----</option>
                {selectData.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="lessonName"
                value={data.lessonName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon
                  className="iconeForm"
                  icon={faPersonChalkboard}
                />
                <span className="textinpout">اسم الدرس</span>
              </Form.Label>
            </Form.Group>

            {/* وصف الدرس */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="lessonDescription"
                value={data.lessonDescription}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faFileContract} />
                <span className="textinpout">وصف الدرس</span>
              </Form.Label>
            </Form.Group>

            {/* محتوي الدرس */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="lessonContent"
                value={data.lessonContent}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faFileContract} />
                <span className="textinpout">محتوي الدرس</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="lessonVideoUrl"
                value={data.lessonVideoUrl}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faLink} />
                <span className="textinpout">رابط الفيديو:</span>
              </Form.Label>
            </Form.Group>

            {/* الواجب الدراسي */}
            <div className="border p-4 rounded-3 mb-5 bg-light text-end">
              <h5 className="fw-bold mb-4 text-purple" style={{ color: "var(--brand-purple)" }}>الواجب الدراسي (اختياري)</h5>
              
              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  className="inpoutFeald"
                  type="text"
                  name="assignmentTitle"
                  value={data.assignmentTitle}
                  onChange={handleChange}
                  placeholder=" "
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faFileContract} />
                  <span className="textinpout">عنوان الواجب</span>
                </Form.Label>
              </Form.Group>

              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  as="textarea"
                  rows={2}
                  className="inpoutFeald"
                  name="assignmentDescription"
                  value={data.assignmentDescription}
                  onChange={handleChange}
                  placeholder=" "
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faFileContract} />
                  <span className="textinpout">وصف/تعليمات الواجب</span>
                </Form.Label>
              </Form.Group>

              <Form.Group className="text-end">
                <Form.Label className="small text-muted mb-2">تحديث ملف الواجب المرفق (اتركه فارغاً للاحتفاظ بالملف الحالي - أي نوع ملف):</Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) => setAssignmentFile(e.target.files[0])}
                />
              </Form.Group>
            </div>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                تعديل
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
